import React from "react";

const Block = () => {
  return <div>your account has been block</div>;
};

export default Block;
